import { render, staticRenderFns } from "./SoButton.vue?vue&type=template&id=4b73dd1b&scoped=true&"
import script from "./SoButton.vue?vue&type=script&lang=js&"
export * from "./SoButton.vue?vue&type=script&lang=js&"
import style0 from "./SoButton.vue?vue&type=style&index=0&id=4b73dd1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b73dd1b",
  null
  
)

export default component.exports